import React from "react";
import { Button, Dropdown, Menu, Space } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import Styles from "./dropdown.module.scss";

const DropDownOptions = ({ optionsList, changeHandler }) => {
  return (
    <Menu selectable popupClassName="action-dropdown" onClick={changeHandler}>
      {optionsList.map((item) => (
        <Menu.Item style={{ fontSize: "15px", fontWeight: "500" }} key={item}>
          {item}
        </Menu.Item>
      ))}
    </Menu>
  );
};
const CoffeeDropDown = ({ label, optionsList, changeHandler }) => {
  return (
    <Dropdown
      arrow
      overlay={
        <DropDownOptions
          optionsList={optionsList}
          changeHandler={changeHandler}
        />
      }
      trigger={["click"]}
      placement="bottomLeft"
      className={Styles["action-dropdown"]}
      overlayClassName="Actiondropdown"
    >
      <Button style={{ padding: "0 15px" }}>
        <Space>
          {label}
          <CaretDownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default CoffeeDropDown;
